// Authentication utilities for robust logout and desktop compatibility

export const cleanupAuthState = () => {
  console.log("🧹 Starting auth state cleanup...");
  
  try {
    // Remove standard auth tokens
    const authKeys = [
      'supabase.auth.token',
      'sb-auth-token'
    ];
    
    // Remove history-related localStorage keys to prevent data leakage
    const historyKeys = [
      'createJoyHistory',
      'savedIdeas', 
      'capturedImage'
    ];
    
    console.log("🗂️ Clearing history data for user privacy");
    historyKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`✅ Removed history key: ${key}`);
    });
    
    // Remove all Supabase auth keys from localStorage
    const allLocalStorageKeys = Object.keys(localStorage);
    const supabaseKeys = allLocalStorageKeys.filter(key => 
      key.startsWith('supabase.auth.') || 
      key.includes('sb-') || 
      authKeys.includes(key)
    );
    
    console.log("🔑 Found auth keys to remove:", supabaseKeys);
    
    supabaseKeys.forEach(key => {
      localStorage.removeItem(key);
      console.log(`✅ Removed localStorage key: ${key}`);
    });
    
    // Remove from sessionStorage if available
    if (typeof sessionStorage !== 'undefined') {
      const allSessionStorageKeys = Object.keys(sessionStorage);
      const sessionSupabaseKeys = allSessionStorageKeys.filter(key => 
        key.startsWith('supabase.auth.') || 
        key.includes('sb-') || 
        authKeys.includes(key)
      );
      
      sessionSupabaseKeys.forEach(key => {
        sessionStorage.removeItem(key);
        console.log(`✅ Removed sessionStorage key: ${key}`);
      });
    }
    
    console.log("✨ Auth state cleanup completed");
  } catch (error) {
    console.error("❌ Error during auth cleanup:", error);
  }
};

export const isDesktop = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth >= 768;
};

export const logAuthEvent = (event: string, details?: any) => {
  const platform = isDesktop() ? 'desktop' : 'mobile';
  console.log(`🔐 Auth Event [${platform}]: ${event}`, details || '');
};

export const forcePageRefresh = (url: string = '/') => {
  console.log(`🔄 Force refresh to: ${url}`);
  
  // Use window.location for complete state reset
  if (typeof window !== 'undefined') {
    window.location.href = url;
  }
};